export const STORAGE_KEY = 'ie-menu-state';
export const THEME_KEY = 'ie-theme-color';
